// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".oh-progress {\n  border: 1px solid #fff;\n  height: 27px;\n  width: 400px;\n  border-radius: 2px;\n  display: inline-flex;\n  padding: 2px;\n}\n.oh-progress-bar {\n  background: linear-gradient(to bottom, #bacad3 50%, #8ca1ad 50%);\n  flex: 0 auto;\n  width: 25%;\n}\n", ""]);
// Exports
module.exports = exports;
